import React, { useEffect} from 'react'


import { Container } from 'react-bootstrap'



const Contact = props => {

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])
	
	return (
		<div className="main">
			<Container className="text-center ">
				<h1>Contact Us</h1>

				<form className="py-5 mx-auto">
					<div className="form-group row">
						<label htmlFor="staticPhone" className="col col-form-label">Phone</label>
						<div className="col">
						<input type="text" readonly className="form-control-plaintext " id="staticEmail" value="801-357-89321"></input>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="staticEmail" className="col col-form-label">Email</label>
						<div className="col">
						<input type="text" readonly className="form-control-plaintext " id="staticEmail" value="email@example.com"></input>
						</div>
					</div>
		
				</form>
		
			</Container>
		</div>


		
	)
}

export default Contact;